import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink, CheckCircle, Shield, Zap } from 'lucide-react';
import { PageTransition } from '../components/shared/PageTransition';
import { SEOHelmet } from '../components/seo/SEOHelmet';
import { Button } from '../components/ui/Button';
import styles from './OpenAccount.module.css';

export const OpenAccount: React.FC = () => {
  const { t } = useTranslation();

  const handleOpenAccount = () => {
    window.open('https://pay.gcbusiness.space/site/home', '_blank', 'noopener,noreferrer');
  };

  const features = [
    {
      icon: <CheckCircle size={32} />,
      title: t('openAccount.feature1Title'),
      description: t('openAccount.feature1Description'),
    },
    {
      icon: <Shield size={32} />,
      title: t('openAccount.feature2Title'),
      description: t('openAccount.feature2Description'),
    },
    {
      icon: <Zap size={32} />,
      title: t('openAccount.feature3Title'),
      description: t('openAccount.feature3Description'),
    },
  ];

  return (
    <PageTransition>
      <SEOHelmet
        title={t('seo.openAccount.title')}
        description={t('seo.openAccount.description')}
        canonical="https://gcbusiness.space/open-account"
      />
      <div className={styles.openAccountPage}>
        <div className={styles.container}>
          <h1 className={styles.title}>{t('openAccount.title')}</h1>
          <p className={styles.subtitle}>{t('openAccount.subtitle')}</p>

          <div className={styles.featuresGrid}>
            {features.map((feature, index) => (
              <div key={index} className={styles.featureCard}>
                <div className={styles.featureIcon}>{feature.icon}</div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>

          <div className={styles.ctaSection}>
            <h2 className={styles.ctaTitle}>{t('openAccount.ctaTitle')}</h2>
            <p className={styles.ctaText}>{t('openAccount.ctaText')}</p>
            
            <Button onClick={handleOpenAccount} className={styles.ctaButton}>
              <span>{t('openAccount.ctaButton')}</span>
              <ExternalLink size={20} className={styles.externalIcon} />
            </Button>

            <p className={styles.disclaimer}>{t('openAccount.disclaimer')}</p>
          </div>

          <div className={styles.infoSection}>
            <h3 className={styles.infoTitle}>{t('openAccount.requirementsTitle')}</h3>
            <ul className={styles.requirementsList}>
              <li>{t('openAccount.requirement1')}</li>
              <li>{t('openAccount.requirement2')}</li>
              <li>{t('openAccount.requirement3')}</li>
              <li>{t('openAccount.requirement4')}</li>
            </ul>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};